import {I18n} from 'react-redux-i18n';

import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';

import subscriptionService from '../../../services/subscription/SubscriptionService';

const DEPOSITOR_SERVICE_IDS = ['fr_depositor_v1', 'de_depositor_v1', 'it_depositor_v1'];

function isDepositorPlan({services = []}) {
  return services.some(service => DEPOSITOR_SERVICE_IDS.includes(service.id));
}

const compareServicesByPriority = (service1, service2) => service2.priority - service1.priority;

const filterAndSortServices = services => (
  services
    .flatMap(service => {
      const translatedLabel = I18n.t(`subscriptions.plans.services.${service.id}`, {count: service.quantity, ...service});
      return translatedLabel === service.id ?
        [] : {...service, translatedLabel};
    })
    .sort((service1, service2) => compareServicesByPriority(service1, service2))
);

const getPricePerMonth = ({price, pricePeriod}) => price / ((pricePeriod === 'year') ? 12 : 1);

const comparePlansByPrice = (plan1, plan2) => getPricePerMonth(plan1) - getPricePerMonth(plan2);

function findCurrentPlan(subscription, suggestedPlans = []) {
  if (!subscription || isEmpty(suggestedPlans)) {
    return undefined;
  }

  return suggestedPlans.find(plan => plan.externalId === subscription.planId);
}

const filterFeatures = ({services = []}) => filterAndSortServices(services.filter(service => !service.price));

const filterOptions = ({services = []}) => filterAndSortServices(services.filter(service => !!service.price));

export const getSuggestedPlans = (organisationId, answers) => (
  subscriptionService.getSuggestedPlans(organisationId, answers)
    .then((availablePlans = []) => availablePlans
      .map(plan => ({
        ...plan,
        features: filterFeatures(plan),
        options: filterOptions(plan),
        depositor: isDepositorPlan(plan)
      }))
      .sort(comparePlansByPrice)));

export const getCurrentPlan = organisationId => (
  Promise.all([
    subscriptionService.findSubscriptionByOrganisation(organisationId),
    getSuggestedPlans(organisationId)
  ])
    .then(([currentSubscription, suggestedPlans]) => {
      const selectedCurrentPlan = findCurrentPlan(currentSubscription, suggestedPlans);
      return selectedCurrentPlan;
    })
);

export const findFirstDepositorPlan = selectedPlans => (
  selectedPlans.find(plan => plan.depositor)
);

export const findFirstNonDepositorPlan = selectedPlans => (
  selectedPlans.find(plan => !plan.depositor)
);
